import { api } from './backend'; 

export const post = (data) => api.post('front/ebooks-view/', data);